var DeclineMeetingSelectionState;
(function (DeclineMeetingSelectionState) {
    DeclineMeetingSelectionState[DeclineMeetingSelectionState["UseAutomaticReplyMessage"] = 0] = "UseAutomaticReplyMessage";
    DeclineMeetingSelectionState[DeclineMeetingSelectionState["CreateNewMessage"] = 1] = "CreateNewMessage";
})(DeclineMeetingSelectionState || (DeclineMeetingSelectionState = {}));
export default DeclineMeetingSelectionState;
//# sourceMappingURL=DeclineMeetingSelectionState.js.map